import { z } from 'zod';

import { QuestionnaireTypeCodeZod } from './questionnaire-type-code';

import { DocumentZod } from 'types/zod/document';
import { QInstanceStatusZod } from 'types/zod/qinstance-status';

export const QuestionnaireInstanceZod = z.object({
    questionnaire_instance_id: z.number(),
    questionnaire_id: z.number(),
    originator_participant_id: z.number(),
    state_code: z.string(),
    questionnaire_type_code: QuestionnaireTypeCodeZod,
    date_added: z.number(),
    date_modified: z.number().optional(),
    status: QInstanceStatusZod,
    name: z.string(),
    location_description: z.string().nullable().optional(),
    to_be_mailed: z.boolean().nullable().optional(),
    documents: z.array(DocumentZod).nullable().optional(),
    parent_questionnaire_instance_id: z.number().nullable().optional(),
});
export type QuestionnaireInstance = z.infer<typeof QuestionnaireInstanceZod>;
